
export type SideBarUrlData = {
  title?: string;
  open?: boolean;
  slug?: string;
  urldata?: SideBarUrlData[];
};

export type SideBarUrlsData = Array<SideBarUrlData>;

export type PrevOrNextLink = {
  title: string;
  slug: string;
};

export default function Page() {
  return <div />;
}
